<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="downtimes"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
      :date="date"
      :externalFilters="sortColumn"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center justify-content-start">
        <h1 class="mr-4">Простои</h1>
        <form>
          <div class="mt-1">
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="checklist-type-1" class="custom-control-input" v-model="sortColumn" value="_term">
              <label class="custom-control-label" for="checklist-type-1">Время начала</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="checklist-type-2" class="custom-control-input" v-model="sortColumn" value="time">
              <label class="custom-control-label" for="checklist-type-2">Простой</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="checklist-type-3" class="custom-control-input" v-model="sortColumn" value="workTime">
              <label class="custom-control-label" for="checklist-type-3">Режим работы</label>
            </div>
          </div>
        </form>

        <btn-filters
          class="ml-auto"
          :data="data"
          endpoint="downtimes"
          v-model="filtersValue"
          :range="true"
          :date.sync="date"
        ></btn-filters>
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
        @sort-change="sortChange"
      >
        <table-column-serial-number sortable="keyword"/>
        <el-table-column prop="address" label="Адрес установки"/>
        <el-table-column :colspan="col" align="center" label="Время начала простоя">
          <template slot-scope="{row}">
            <div class="downtimes-item" v-for="index in row.downtimes">
              {{ index.start_time | formatStartTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Время простоя">
          <template slot-scope="{row}">
            <div class="downtimes-item" v-for="index in row.downtimes">
              {{ index.duration | formatDuration }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Простой с учетом режима работы">
          <template slot-scope="{row}">
            <div class="downtimes-item" v-for="index in row.downtimes">
              {{ index.durationWorkTime | formatDuration }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Общее время простоев">
          <template slot-scope="{row}">
            {{ row.sum | formatDuration }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="Общее время простоев с учетом режима работы">
          <template slot-scope="{row}">
            {{ row.sumWorkTime | formatDuration }}
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    metaInfo: {title: 'Простои'},
    data () {
      return {
        col: 2,
        filtersValue: null,
        data: {},
        loading: false,
        hasMore: true,
        date: {
          min: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          max: moment().format('YYYY-MM-DD'),
        },
        sort: null,
        sortColumn: '_term',
      }
    },
    filters: {
      formatStartTime (microseconds) {
        return moment.unix(microseconds / 1000).format('DD.MM.YYYY HH:mm:ss')
      },
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          const prop = sort.prop + '.keyword'
          this.sort = `${prop}:${order}`
        } else {
          this.sort = null
        }
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .downtimes-item + .downtimes-item {
    border-top: 1px solid $gray-200;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/reports/downtime.vue